/**
 * personalProjectService — the Personal space's binding of the projects layer.
 *
 * Same machinery as Work (see projectServiceFactory.js), pointed at a separate
 * collection. `personalProjects` is walled by isOwner() in firestore.rules,
 * matching every other Personal collection.
 *
 * WRITABLE, unlike Work. This is the whole point of the slice: Anthony asked to
 * be able to create projects in Personal, and no project create path existed
 * anywhere. The asymmetry is deliberate and is enforced by the factory rather
 * than by convention — Work's service does not carry the writers at all.
 */

import { createProjectService } from './projectServiceFactory';

const personalProjectService = createProjectService({
	projectsCollection: 'personalProjects',
	space: 'personal',
	writable: true,
});

export default personalProjectService;
